export const validatationRoutes = [
    { path: "event/create", action: "createEvent" },
    { path: "event/update", action: "updateEvent" },
    { path: "event/delete", action: "deleteEvent" },
    { path: "transaction/nodes", action: "getTransactionNodes" },
    { path: "transaction/delete", action: "deleteTransaction" },
    { path: "transaction/order/update", action: "updateTransactionElementsOrder" },
    { path: "transaction/nested-transaction/delete", action: "deleteNestedTransaction" },
    { path: "transaction/nested-transaction/update", action: "updateNestedTransaction" },
    { path: "transaction/clone", action: "cloneTransaction" },
    { path: "transaction/clusterlets/remap", action: "remapClusterlets" },
    { path: "rrdef/create", action: "createRRDef" },
    { path: "rrdef/update", action: "updateRRDef" },
    { path: "rrdef/delete", action: "deleteRRDef" },
    { path: "delegate/update", action: "updateDelegate" },
    { path: "platformschema/migrate", action: "migratePlatformSchema" },
    { path: "blueprint/undo", action: "undoBlueprint" },
    { path: "blueprint/redo", action: "redoBlueprint" },
    { path: "ai/transaction/events", action: "llmGenerateTransactionEvents" },
    { path: "ai/views/heirarchy", action: "llmGenerateViews" },
    { path: "view/create", action: "createView"},
    { path: "view/update", action: "updateView"},

    {path: "simulation/testsuite/update", ation: "testsuiteUpdate"},
    {path: "simulation/testsuite/delete", ation: "testsuiteDelete"},
    {path: "simulation/testsuite/context/update", ation: "testsuiteContextUpdate"},

    {path: "testcase/update", ation: "testaseUpdate"},
    {path: "testcase/update-basic-details", ation: "testaseBasicUpdate"},
    {path: "testcase/update-transactions", ation: "testcaseTransactionUpdate"},
    {path: "testcase/update-delegates", ation: "testcaseDelegatesUpdate"},
    {path: "testcase/paste", ation: "testcasePaste"},
    {path: "simulation/add-transaction", ation: "testcaseAddTransaction"},
    {path: "simulation-transaction/event/update", ation: "testcaseEventUpdate"},
    {path: "testcase/delete", ation: "testcaseDelete"},
    {path: "testcase/context/update", ation: "testcaseContextUpdate"},

    {path: "ai/views/save-generated-entities", ation: "genereateViewsUsingAI"},
    {path: "ai/transaction/handler-code", ation: "generateTransactionUsingAI"},
    {path: "ai/simulation/message", ation: "generateTestsuiteUsingAI"},
    {path: "ai/simulation/testsuite/update", ation: "updateTestsuiteUsingAI"},
    {path: "ai/simulation/testsuite/confirm-modifications", ation: "modifyTestsuiteConfirmUsingAI"},


]


